import React from "react";
import styled from "styled-components";

const HamburgerButton = styled.div`
  width: 34px;
  height: 40px;
  @media screen and (min-width: 1200px) {
    display: none;
  }
`;
const HamburgerItem = styled.span`
  display: block;
  height: 3px;
  background-color: #fff;
  margin-top: 10px;
  width: 100%;

`;

const HamburgerMenu = ({isOpen, open}) => {

  return (
    <HamburgerButton onClick={() => open(!isOpen)}>
      <HamburgerItem/>
      <HamburgerItem/>
      <HamburgerItem/>
    </HamburgerButton>
  )
}

export default HamburgerMenu;
